var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"card-view--plannings"}},[_c('b-row',_vm._l((_vm.plannings),function(planning,index){return _c('b-col',{key:index,attrs:{"cols":"4"}},[_c('cards-view-card',{attrs:{"planning":planning}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }